export class Alert {
  id: string;
  type: AlertType;
  icon: string;
  message: string;
  autoClose: boolean;
  keepAfterRouteChange: boolean;
  fade: boolean;
  supportingText: string;
  openTicket: string;
  openTicketIcon: string;

  constructor(init?:Partial<Alert>) {
    Object.assign(this, init);
  }
}

export enum AlertType {
  Success,
  Info,
  Warning
}
